const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: null,
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/vendor-linkings`, {
                method: "POST",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/vendor-linkings/${params.id}`, {
                method: "PUT",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                commit( 'setItem', response.data.data);
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deteleItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/vendor-linkings`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"detail",val:true});
            global.axios.get(`/api/vendor-linkings/${params}`)
                .then(response => {
                    commit( 'setLoadings', {key:"detail",val:false});
                    commit( 'setItem', response.data.data);
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getList({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/vendor-linkings`, {params:params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setItem (state, data) {
        state.Item = data;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}